/* ── ZYRA THEME JS ── */

document.addEventListener('DOMContentLoaded', function () {

    // ── ANNOUNCEMENT BAR HEIGHT ──
    var bar = document.querySelector('.announcement-bar');
    function setAnnouncementHeight() {
        if (bar) {
            document.body.style.setProperty('--announcement-height', bar.offsetHeight + 'px');
        }
    }
    setAnnouncementHeight();
    window.addEventListener('resize', setAnnouncementHeight);

    // ── HEADER SCROLL ──
    var header = document.getElementById('site-header');
    if (header) {
        function onScroll() {
            if (window.scrollY > 0) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    // ── NAV SIDEBAR ──
    var navSidebar = document.getElementById('nav-sidebar');
    var navSidebarOverlay = document.getElementById('nav-sidebar-overlay');
    var navSidebarClose = document.getElementById('nav-sidebar-close');
    var navToggleBtns = document.querySelectorAll('.nav-toggle-btn');

    function openNavSidebar() {
        if (navSidebar) navSidebar.classList.add('open');
        if (navSidebarOverlay) navSidebarOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeNavSidebar() {
        if (navSidebar) navSidebar.classList.remove('open');
        if (navSidebarOverlay) navSidebarOverlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    navToggleBtns.forEach(function (btn) {
        btn.addEventListener('click', openNavSidebar);
    });
    if (navSidebarClose) navSidebarClose.addEventListener('click', closeNavSidebar);
    if (navSidebarOverlay) navSidebarOverlay.addEventListener('click', closeNavSidebar);

    // ── CART COUNT ──
    function updateCartCount(count) {
        document.querySelectorAll('.cart-count, #cart-count').forEach(function (el) {
            el.textContent = count;
            el.style.display = count > 0 ? 'flex' : 'none';
        });
    }

    fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); });

    // ── TOAST NOTIFICATION ──
    window.showToast = function (msg) {
        var existing = document.getElementById('zyra-toast');
        if (existing) existing.remove();
        var toast = document.createElement('div');
        toast.id = 'zyra-toast';
        toast.textContent = msg;
        toast.style.cssText = [
            'position:fixed',
            'bottom:24px',
            'left:50%',
            'transform:translateX(-50%) translateY(12px)',
            'background:var(--color-charcoal)',
            'color:var(--color-ivory)',
            'padding:12px 24px',
            'font-size:13px',
            'letter-spacing:0.05em',
            'border-left:3px solid var(--color-gold)',
            'z-index:9999',
            'opacity:0',
            'transition:all 0.3s',
            'white-space:nowrap',
            'font-family:var(--font-sans)'
        ].join(';');
        document.body.appendChild(toast);
        requestAnimationFrame(function () {
            toast.style.opacity = '1';
            toast.style.transform = 'translateX(-50%) translateY(0)';
        });
        setTimeout(function () {
            toast.style.opacity = '0';
            toast.style.transform = 'translateX(-50%) translateY(12px)';
            setTimeout(function () { toast.remove(); }, 300);
        }, 2800);
    };

    // ── WISHLIST: UPDATE COUNT BADGES ──
    window.updateWishlistCounts = function (count) {
        var desktopCount = document.getElementById('wishlist-count');
        var mobileCount = document.getElementById('wishlist-count-mobile');
        if (desktopCount) {
            desktopCount.textContent = count;
            desktopCount.style.display = count > 0 ? 'flex' : 'none';
        }
        if (mobileCount) {
            mobileCount.textContent = count;
            mobileCount.style.display = count > 0 ? 'flex' : 'none';
        }
    };

    // ── WISHLIST: RENDER DRAWER ──
    window.renderWishlistDrawer = function () {
        var wl = JSON.parse(localStorage.getItem('zyra_wishlist') || '[]');

        wl = wl.filter(function (item) {
            return item && typeof item === 'object' && item.id && item.title && item.title !== 'undefined';
        });
        localStorage.setItem('zyra_wishlist', JSON.stringify(wl));

        var container = document.getElementById('wishlist-drawer-items');
        if (!container) return;

        if (wl.length === 0) {
            container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>';
        } else {
            container.innerHTML = wl.map(function (item) {
                return '<div class="wishlist-item">' +
                    '<img src="' + item.image + '" alt="' + item.title + '">' +
                    '<div class="wishlist-item-info">' +
                    '<a href="' + item.url + '" class="wishlist-item-title">' + item.title + '</a>' +
                    '<span class="wishlist-item-price">PKR ' + item.price + '</span>' +
                    '</div>' +
                    '<button class="wishlist-item-remove" onclick="removeFromWishlistDrawer(\'' + item.id + '\')" aria-label="Remove">✕</button>' +
                    '</div>';
            }).join('');
        }

        window.updateWishlistCounts(wl.length);
    };

    // ── WISHLIST: TOGGLE ──
    window.toggleWishlist = function (btn, event) {
        if (event && event.stopPropagation) event.stopPropagation();

        var id = btn.getAttribute('data-id');
        var title = btn.getAttribute('data-title');
        var image = btn.getAttribute('data-image') || '';
        var url = btn.getAttribute('data-url') || '';
        var price = btn.getAttribute('data-price') || '';

        if (!id || !title || title === 'undefined') {
            window.showToast('Error: missing product data');
            return;
        }

        var wl = JSON.parse(localStorage.getItem('zyra_wishlist') || '[]');
        var existsIndex = wl.findIndex(function (i) { return i.id === String(id); });

        if (existsIndex > -1) {
            wl.splice(existsIndex, 1);
            window.showToast('Removed from wishlist');
        } else {
            wl.push({ id: String(id), title: title, image: image, url: url, price: price });
            window.showToast('Added to wishlist ✓');
        }

        localStorage.setItem('zyra_wishlist', JSON.stringify(wl));

        document.querySelectorAll('.product-card-heart[data-id="' + id + '"], .wishlist-btn[data-id="' + id + '"]').forEach(function (b) {
            var isNowWishlisted = wl.some(function (i) { return i.id === String(id); });
            b.classList.toggle('wishlisted', isNowWishlisted);
            var svg = b.querySelector('svg');
            if (svg) {
                svg.style.fill = isNowWishlisted ? 'var(--color-gold)' : 'none';
                svg.style.stroke = isNowWishlisted ? 'var(--color-gold)' : 'currentColor';
            }
            var text = b.querySelector('.wishlist-text');
            if (text) text.textContent = isNowWishlisted ? 'Remove from Wishlist' : 'Save to Wishlist';
        });

        window.renderWishlistDrawer();
    };

    // ── WISHLIST: REMOVE FROM DRAWER ──
    window.removeFromWishlistDrawer = function (id) {
        var wl = JSON.parse(localStorage.getItem('zyra_wishlist') || '[]');
        wl = wl.filter(function (i) { return i.id !== String(id); });
        localStorage.setItem('zyra_wishlist', JSON.stringify(wl));

        document.querySelectorAll('.product-card-heart[data-id="' + id + '"], .wishlist-btn[data-id="' + id + '"]').forEach(function (b) {
            b.classList.remove('wishlisted');
            var svg = b.querySelector('svg');
            if (svg) { svg.style.fill = 'none'; svg.style.stroke = 'currentColor'; }
            var text = b.querySelector('.wishlist-text');
            if (text) text.textContent = 'Save to Wishlist';
        });

        window.renderWishlistDrawer();
        window.showToast('Removed from wishlist');
    };

    // ── WISHLIST: CLOSE ON OVERLAY CLICK ──
    var wishlistOverlay = document.getElementById('wishlist-overlay');
    var wishlistDrawer  = document.getElementById('wishlist-drawer');

    if (wishlistOverlay && wishlistDrawer) {
        wishlistOverlay.addEventListener('click', function () {
            wishlistDrawer.classList.remove('open');
            wishlistOverlay.classList.remove('open');
        });
    }

    // Also close on Escape key (cart, wishlist, nav sidebar)
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            var cartDrawer   = document.getElementById('cart-drawer');
            var cartOverlay  = document.getElementById('cart-overlay');
            if (cartDrawer)   cartDrawer.classList.remove('open');
            if (cartOverlay)  cartOverlay.classList.remove('open');
            if (wishlistDrawer)  wishlistDrawer.classList.remove('open');
            if (wishlistOverlay) wishlistOverlay.classList.remove('open');
            closeNavSidebar();
        }
    });

    // ── INIT WISHLIST ON PAGE LOAD ──
    var wl = JSON.parse(localStorage.getItem('zyra_wishlist') || '[]');
    window.updateWishlistCounts(wl.length);

    document.querySelectorAll('.product-card-heart, .wishlist-btn').forEach(function (btn) {
        var id = btn.getAttribute('data-id');
        if (wl.some(function (i) { return i.id === String(id); })) {
            btn.classList.add('wishlisted');
            var svg = btn.querySelector('svg');
            if (svg) { svg.style.fill = 'var(--color-gold)'; svg.style.stroke = 'var(--color-gold)'; }
            var text = btn.querySelector('.wishlist-text');
            if (text) text.textContent = 'Remove from Wishlist';
        }
    });

    window.renderWishlistDrawer();

});